import { createGlobalStyle } from 'styled-components';
import './index.css';
import './normalize.css';

export const theme = {
  brand: '#fbbf24',
  success: '#34d399',
  danger: '#f43f5e',

  backgroundColor: '#27272a',
  foregroundColor: '#313135',

  textColor: '#e4e4e7',
  mutedColor: '#71717A',

  clear25: '40',
  clear50: '80',
  clear75: 'BF',

  fontFamily: 'Be Vietnam Pro',
  sizeLg: '16px',
  sizeMd: '14px',
  sizeSm: '12px',
  sizeXs: '10px',
  sizeBody: '1rem',
  sizeSmall: '0.875rem',
  sizeH1: '3rem',
  sizeH2: '2.25rem',
  sizeH3: '2rem',
  sizeH4: '1.5rem',
  sizeH5: '1.25rem',
  sizeH6: '1.125rem',
  headerWeight: '600',
  normalWeight: '400',
  headerSpacing: '0.15em',
  normalSpacing: '0.1em',

  borderRadiusSm: '0.5rem',
  borderRadiusMd: '1rem',
  borderRadiusLg: '2rem',
  borderRadiusXl: '3rem',
  borderFull: '999px',

  spaceXs: '0.25rem',
  spaceSm: '0.5rem',
  spaceMd: '1rem',
  spaceLg: '2rem',
  spaceXl: '3rem',

  paddingSm: '0.25rem 0.5rem',
  paddingMd: '0.5rem 1rem',
  paddingLg: '1rem 1.5rem',

  breakpoints: {
    width: {
      sm: '640px',
      md: '768px',
      lg: '1024px',
      xl: '1280px',
      xxl: '1536px',
    },
    height: {
      sm: '320px',
      md: '432px',
      lg: '576px',
      xl: '720px',
      xxl: '864px',
    },
  },

  transition: '0.125s ease-in-out',
  transitionLong: '0.25s ease-in-out',

  delaySm: 0.25,
  delayMd: 0.5,
  delayLg: 0.75,
  delayXl: 1,
  
  fadeIn: {
    initial: { opacity: 0 },
    animate: {opacity: 1},
    transition: (delay) => ({
      duration: 0.5,
      ease: 'easeInOut',
      delay: delay,
    })
  }
};

export const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  html {
    --nav-height: 12rem;
    --sidenav-width: 3rem;
    font-size: ${props => props.theme.sizeXs};
    font-family: ${props => props.theme.fontFamily}, sans-serif;

    @media only screen and (min-width: ${props => props.theme.breakpoints.width.sm}) {
      --nav-height: 3.5rem;
      font-size: ${props => props.theme.sizeSm};
    }

    @media only screen and (min-width: ${props => props.theme.breakpoints.width.md}) {
      font-size: ${props => props.theme.sizeMd};
    }

    @media only screen and (min-width: ${props => props.theme.breakpoints.width.lg}) {
      --sidenav-width: 12rem;
      font-size: ${props => props.theme.sizeLg};
    }

    @media only screen and (min-width: ${props => props.theme.breakpoints.width.xl}) {
      --sidenav-width: 13rem;
    }
  }

  body {
    margin: 0;
    padding: 0;

    background-color: ${props => props.theme.backgroundColor};
    color: ${props => props.theme.textColor};
  }

  h1, h2, h3, h4, h5, h6, p, a, label {
    line-height: 1;
    margin: 0;
  }

  h1, h2, h3, h4, h5, h6 {
    text-transform: uppercase;
    letter-spacing: ${props => props.theme.headerSpacing};
    font-weight: ${props => props.theme.headerWeight};
  }

  h1 {
    font-size: ${props => props.theme.sizeH1};
  }

  h2 {
    font-size: ${props => props.theme.sizeH2};
  }

  h3 {
    font-size: ${props => props.theme.sizeH3};
  }

  h4 {
    font-size: ${props => props.theme.sizeH4};
  }

  h5 {
    font-size: ${props => props.theme.sizeH5};
  }

  h6 {
    font-size: ${props => props.theme.sizeH6};
  }

  p, a, label {
    font-weight: ${props => props.theme.normalWeight};
    letter-spacing: ${props => props.theme.normalSpacing};
    color: ${props => props.theme.textColor};
  }

  a {
    text-decoration: none;
    cursor: pointer;
  }

  button {
    display: flex;
    justify-content: center;
    align-items: center;

    font-weight: ${props => props.theme.headerWeight};
    letter-spacing: ${props => props.theme.headerSpacing};
    text-transform: uppercase;
    border-radius: ${props => props.theme.borderFull};
    outline: 0;

    transition: ${props => {
      return ['scale', 'background-color', 'border-color', 'color', 'box-shadow']
        .map(style => `${style} ${props.theme.transition}`)
        .join(',');
    }};

    cursor: pointer;
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  
  ::-webkit-scrollbar-track {
    background: transparent
  }
  
  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme.mutedColor + props.theme.clear50};
    border-radius: ${props => props.theme.borderFull};
    transition: background ${props => props.theme.transition};
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${props => props.theme.mutedColor};
  }
`;
